import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { buildUrl } from 'utils';
import Loading from 'components/Loading';
import useStyles from './AlarmsWidget.styled';
import { useHistory } from 'react-router-dom';
import { Box, Button, Typography } from '@material-ui/core';
import { Card, ItemsList } from 'components/UI';
import { AlarmsActions } from 'state/modules/alarms';

const AlarmsWidget = ({ id, type }) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [params, setParams] = useState({
    page: 1,
    limit: 5,
    actionable: true,
  });
  const { loading, list, pagination } = useSelector((state) => state.alarms || {});

  /**
   * Get comments
   * @param {object} params
   */
  const getAlarms = (params) => {
    const payload = {
      active: true,
      ...params,
    };

    if (id) {
      payload.object_id = id;
    }
    if (type) {
      payload.object_class = type;
    }

    dispatch(AlarmsActions.fetchAlarms(payload));
  };

  /**
   * Handle page change
   * @param {object} event
   * @param {number} newPage New page selected
   */
  const handleChangePage = (event, newPage) => {
    const newParams = { ...params, page: newPage + 1 };
    setParams(newParams);
    getAlarms(newParams);
  };

  /**
   * Handle limit / page size change
   * @param {object} event Value of the input
   */
  const handleChangeRowsPerPage = (event) => {
    const newParams = { ...params, limit: event.target.value };
    setParams(newParams);
    getAlarms(newParams);
  };

  /**
   * Vertical menu list
   * It has the label and the function for each action
   */
  const items = [];

  const title = (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Typography color="textPrimary" component="span">
        <Box fontSize={14} fontWeight="fontWeightMedium" data-cy="alarm-title">
          {i18n.t('alarms.title')}
        </Box>
      </Typography>
      <Button
        type="button"
        variant="text"
        color="primary"
        data-cy="view-all-alarms"
        disableFocusRipple={true}
        className={classes.button}
        onClick={() => {
          const params = id ? `?object_id=${id}&object_class=${type}` : '';
          history.push(buildUrl(`/alarms${params}`));
        }}
      >
        {i18n.t('alarms.view_all')}
      </Button>
    </Box>
  );

  useEffect(() => {
    getAlarms(params);
  }, []); // eslint-disable-line

  return (
    <Card title={title} menuItems={items} headerActionType="vertical" data-cy="alarms-widget-card">
      <Box className={classes.container}>
        {loading ? (
          <Box
            className={classes.loadingContainer}
            justifyContent="center"
            alignItems="center"
            display="flex"
          >
            <Loading />
          </Box>
        ) : (
          <ItemsList
            list={list}
            params={params}
            pagination={pagination}
            dateField="created_time"
            rowsPerPageOptions={[5]}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            placeholder={i18n.t('alarms.alarms_placeholder')}
            handleItemClick={(id) => history.push(buildUrl(`/alarms/${id}`))}
          />
        )}
      </Box>
    </Card>
  );
};

AlarmsWidget.propTypes = {
  id: PropTypes.number,
  type: PropTypes.string,
};

export default AlarmsWidget;
